import React from 'react';
import { Link } from 'react-router-dom';
import { momAndDaughterBakingImg, vinylRoseImg } from '../../data/products';
import './HomeHero.css';

const HomeHero: React.FC = () => (
  <section className="home-hero" aria-label="Hero">
    <div className="home-hero__inner">
      {/* Left: artwork placeholder until real painting photography is added */}
      <div className="home-hero__image home-hero__image--art">
        <img
          src={momAndDaughterBakingImg}
          alt="Original landscape painting by Micah Lynise"
          width={520}
          height={480}
        />
      </div>

      {/* Center: copy */}
      <div className="home-hero__copy">
        <h1 className="home-hero__headline">
          Art that satisfies<br />the five senses.
        </h1>
        <p className="home-hero__sub">
          Fine art, natural fragrances, body care,<br />
          and original music by Micah Lynise.
        </p>
        <div className="home-hero__actions">
          <Link to="/fragrance" className="home-hero__cta-primary">
            Explore the Collection
          </Link>
          <Link to="/about" className="home-hero__cta-secondary">
            Meet the Artist
          </Link>
        </div>
      </div>

      {/* Right: real Vinyl Rose product */}
      <div className="home-hero__image home-hero__image--product">
        <img
          src={vinylRoseImg}
          alt="Vinyl Rose Natural Perfume Oil by Micah Lynise"
          width={340}
          height={480}
        />
      </div>
    </div>
  </section>
);

export default HomeHero;
